import { Component, effect, inject, OnDestroy, OnInit } from '@angular/core';
// import { computed, untracked } from '@angular/core'; // COUNTER DISATTIVATI
import { MailboxService } from '../../../services/mailbox.service';
import { MailService } from '../../../services/mail.service';
// import { CountParams } from '../../../services/mail.service'; // COUNTER DISATTIVATI
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { RouterOutlet } from '@angular/router';
import { ComposeDialogComponent } from '../../shared/dialogs/compose/compose.dialog';
import { StorageService } from '../../../services/storage.service';
import { UtilsService } from '../../../services/utils.service';
import { WebsocketService } from '../../../services/websocket.service';
import { UtentiService } from '../../../services/utenti.service';
import { NotificaMessaggioRTO, SyncRequestCasellaRTO, WSErrorRTO } from '../../../models/websocket.model';
import { AppStateService } from '../../core/services/app-state.service';
import { Mailbox } from '../../../models/mailbox.model';
import { Subscription } from 'rxjs';
// COUNTER DISATTIVATI
// import { MailType } from '../../../models/mail.model';
// import { catchError, debounceTime, EMPTY, forkJoin, map, mergeMap, Observable, of, tap } from 'rxjs';
import {ContactsService} from '../../../services/contacts.service';
import { ListaDistribuzioneService } from '../../../services/lista-distribuzione.service';

// COUNTER DISATTIVATI: filtri /messages/count per sezione
// /**
 // * Filtri /count per sezione: lo stesso insieme mostrato dalla rispettiva lista, così counter e
 // * lista non divergono. Inoltrati in Inviati, soli etichettati in Archivio ed esclusione degli
 // * etichettati dalla Inbox li applica il backend.
 // */
// const FILTRI_CONTATORI: Record<MailType, Omit<CountParams, 'tipo' | 'email'>> = {
  // // Da classificare: non letti, esclusi i già classificati (includeClassified omesso = false).
  // INBOX: { soloNonLetti: true },
  // OUTBOX: {},
  // DRAFT: {},
  // ARCHIVED: {},
// };

@Component({
  selector: 'pec-shell',
  templateUrl: './shell.component.html',
  imports: [SidebarComponent, TopbarComponent, RouterOutlet, ComposeDialogComponent],
})
export class ShellComponent implements OnInit, OnDestroy {
  private readonly mailboxService = inject(MailboxService);
  private readonly mailService = inject(MailService);
  private readonly storageService = inject(StorageService);
  private readonly utilsService = inject(UtilsService);
  private readonly websocketService = inject(WebsocketService);
  private readonly utentiService = inject(UtentiService);
  private readonly state = inject(AppStateService);
  private readonly contattiService = inject(ContactsService);
  private readonly listaDistribuzioneService = inject(ListaDistribuzioneService);

  isLoading = this.utilsService.isLoading;

  private connectionSubscription?: Subscription;
  private syncSubscription?: Subscription;
  private erroriSubscription?: Subscription;
  /** Un'iscrizione a /topic/casella/{id}/messaggi per ogni casella visibile all'utente. */
  private readonly iscrizioniCaselle = new Map<number, Subscription>();
  private wsConnesso = false;
  // COUNTER DISATTIVATI: stato del ricalcolo contatori
  // private countsSubscription?: Subscription;

  // /** Sezioni richieste e non ancora ricalcolate: accorpate nella finestra di debounce. */
  // private readonly contatoriInSospeso = new Set<MailType>();
  // /**
   // * Ultimo giro di conteggio avviato per sezione: un risultato più vecchio che arriva dopo uno
   // * più recente non deve sovrascriverlo.
   // */
  // private readonly ultimoConteggio: Record<MailType, number> = {
    // INBOX: 0,
    // OUTBOX: 0,
    // DRAFT: 0,
    // ARCHIVED: 0,
  // };
  // /** Insieme delle caselle: cambia solo se ne viene aggiunta o tolta una, non a ogni refetch. */
  // private readonly caselleKey = computed(() =>
    // this.mailboxService
      // .mailboxes()
      // .map(mb => mb.email)
      // .sort()
      // .join('|'),
  // );

  constructor() {
    // COUNTER DISATTIVATI: unico punto che interroga /count
    // // Unico punto dell'app che interroga /count. Va sottoscritto prima che gli effect possano
    // // emettere la prima richiesta.
    // this.countsSubscription = this.mailService.countsRefresh$
      // .pipe(
        // tap(tipi => tipi.forEach(t => this.contatoriInSospeso.add(t))),
        // debounceTime(300),
        // mergeMap(() => {
          // const tipi = [...this.contatoriInSospeso];
          // this.contatoriInSospeso.clear();
          // const caselle = untracked(() => this.mailboxService.mailboxes()).map(mb => mb.email);
          // return forkJoin(tipi.map(tipo => this.caricaContatori(tipo, caselle)));
        // }),
      // )
      // .subscribe();

    effect(() => {
      const isSaved = this.storageService.isUserSaved();

      if (isSaved) {
        // Avvia le chiamate solo quando il segnale diventa true
        this.mailboxService.fetchMailboxes();
        this.utentiService.fetchAll();
        this.contattiService.setAll();
        this.listaDistribuzioneService.fetchListeDistribuzione();
      }
    });

    // Allinea le iscrizioni per casella quando cambia l'elenco delle caselle visibili
    // (primo caricamento, casella aggiunta o rimossa). Alla (ri)connessione ci pensa ngOnInit.
    effect(() => {
      const caselle = this.mailboxService.mailboxes();
      if (this.wsConnesso) this.allineaIscrizioniCaselle(caselle);
    });

    // COUNTER DISATTIVATI: ricalcolo al login / cambio caselle
    // // I contatori per casella dipendono dall'elenco delle caselle: si ricalcolano al login e
    // // quando l'insieme cambia (primo caricamento, casella aggiunta o rimossa). Il refetch delle
    // // stesse caselle (es. dopo una sync) non cambia la chiave e non scatena nulla.
    // effect(() => {
      // if (!this.storageService.isUserSaved()) return;
      // this.caselleKey();
      // untracked(() => this.mailService.requestCountsRefresh());
    // });
  }

  // COUNTER DISATTIVATI: chiamate a /messages/count
  // /** Totale + una chiamata per casella; un errore su una sezione non blocca le altre. */
  // private caricaContatori(tipo: MailType, caselle: string[]): Observable<void> {
    // const filtri = FILTRI_CONTATORI[tipo];
    // const giro = ++this.ultimoConteggio[tipo];
    // return forkJoin({
      // all: this.mailService.getCount({ tipo, ...filtri }),
      // perCasella: caselle.length
        // ? forkJoin(caselle.map(email => this.mailService.getCount({ tipo, email, ...filtri })))
        // : of([] as number[]),
    // }).pipe(
      // tap(({ all, perCasella }) => {
        // if (giro !== this.ultimoConteggio[tipo]) return;
        // const byMailbox: Record<string, number> = {};
        // caselle.forEach((email, i) => (byMailbox[email] = perCasella[i]));
        // this.mailService.setCounts(tipo, { all, byMailbox });
      // }),
      // map(() => undefined),
      // catchError(err => {
        // console.error(`[Shell] errore conteggio ${tipo}:`, err);
        // return EMPTY;
      // }),
    // );
  // }

  ngOnInit() {
    this.websocketService.connect().catch(error => {
      console.error('Failed to connect to WebSocket:', error);
    });

    this.connectionSubscription = this.websocketService.isConnected$.subscribe(isConnected => {
      this.wsConnesso = isConnected;
      if (!isConnected) return;

      // Nuova connessione: le iscrizioni precedenti appartenevano alla sessione chiusa, si rifanno da zero.
      this.chiudiIscrizioniCaselle();
      this.allineaIscrizioniCaselle(this.mailboxService.mailboxes());

      // Esito della sincronizzazione: il backend lo manda solo a chi ha creato la casella (coda personale),
      // quindi non serve piu' filtrare lato client su user.sub.
      this.syncSubscription?.unsubscribe();
      this.syncSubscription = this.websocketService.subscribe('/user/queue/casella/sync').subscribe({
        next: (value: SyncRequestCasellaRTO) => {
          if (value.status == 'error') {
            this.state.showToast(value.messaggio, 'error');
          } else {
            this.state.showToast(value.messaggio, 'success');
            this.mailboxService.fetchMailboxes();
            // this.mailService.requestCountsRefresh(); // COUNTER DISATTIVATI
          }
        },
      });

      // Errori delle operazioni WebSocket (es. lock gia' preso) e degli invii falliti: solo i propri.
      this.erroriSubscription?.unsubscribe();
      this.erroriSubscription = this.websocketService.subscribe('/user/queue/errors').subscribe({
        next: (errore: WSErrorRTO) => this.state.showToast(errore.messaggio, 'error'),
      });
    });
  }

  /** Tiene un'iscrizione a /topic/casella/{id}/messaggi per ogni casella dell'elenco, ne' una di piu' ne' una di meno. */
  private allineaIscrizioniCaselle(caselle: Mailbox[]) {
    const ids = new Set(caselle.map(c => c.id));
    for (const [id, sub] of this.iscrizioniCaselle) {
      if (!ids.has(id)) {
        sub.unsubscribe();
        this.iscrizioniCaselle.delete(id);
      }
    }
    for (const casella of caselle) {
      if (casella.id == null || this.iscrizioniCaselle.has(casella.id)) continue;
      this.iscrizioniCaselle.set(
        casella.id,
        this.websocketService.subscribe(`/topic/casella/${casella.id}/messaggi`).subscribe({
          next: (notifica: NotificaMessaggioRTO) => {
            // Il tipo serve solo a decidere il toast: i dati vanno aggiornati sempre, perché un evento
            // può toccare più sezioni (es. una PEC inviata e le sue ricevute archiviate).
            // Ogni pagina ricarica solo se è aperta.
            if (notifica.tipo.toLowerCase() == 'inbox') {
              this.state.showToast(`[${casella.email}] Hai ricevuto una nuova mail da: ${notifica.mittente}`);
              // this.mailService.requestCountsRefresh('INBOX'); // COUNTER DISATTIVATI
            }
            this.mailService.notifyInboxChanged();
            this.mailService.notifySentChanged();
            this.mailService.notifyArchivedChanged();
          },
          error: err => console.error(`[Shell] iscrizione alla casella ${casella.id} fallita:`, err),
        }),
      );
    }
  }

  private chiudiIscrizioniCaselle() {
    this.iscrizioniCaselle.forEach(sub => sub.unsubscribe());
    this.iscrizioniCaselle.clear();
  }

  ngOnDestroy() {
    this.connectionSubscription?.unsubscribe();
    this.syncSubscription?.unsubscribe();
    this.erroriSubscription?.unsubscribe();
    this.chiudiIscrizioniCaselle();
    // this.countsSubscription?.unsubscribe(); // COUNTER DISATTIVATI
  }
}
